import * as React from 'react'
import Chip from '@material-ui/core/Chip'
import PropTypes from 'prop-types'

const StatusChip = ({ value, activeLabel, inactiveLabel }) => {
  const isActive = value === true || value === 1 || value === '1'
  return (
    <Chip
      size="small"
      label={isActive ? activeLabel : inactiveLabel}
      style={{
        backgroundColor: isActive ? '#d1fae5' : '#f1f5f9',
        color: isActive ? '#047857' : '#64748b',
        fontWeight: 600,
      }}
    />
  )
}

StatusChip.propTypes = {
  value: PropTypes.any,
  activeLabel: PropTypes.string.isRequired,
  inactiveLabel: PropTypes.string.isRequired,
}

export default StatusChip
